import { render, staticRenderFns } from "./TaskTagCommonFilters.vue?vue&type=template&id=3e1b15a1&"
import script from "./TaskTagCommonFilters.vue?vue&type=script&lang=js&"
export * from "./TaskTagCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports